export const imageTypes = ['tif', 'tiff', 'bmp', 'jpg', 'jpeg', 'gif', 'png'];
export const VIDEO_TYPES = ['.mp4', '.mov', '.flv', '.wmv', '.avi', '.wfr', '.arf'];
export const defaultImagePlaceholder = 'assets/svg/building_placeholder.svg';

export const enum MediaType {
  Video = 'Video',
  Image = 'Image',
  Document = 'Document',
  Flyer = 'Flyer',
  FloorPlan = 'Floor Plan',
}
